import { Component, OnInit, Injector, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
const swal = require('sweetalert');
import * as ptLocale from 'date-fns/locale/pt';
import { BehaviorSubject } from 'rxjs';
import { LoadingService } from '../../../../util/loader.service';
import { Empresa } from '../../../../models/empresa';
import { EmpresaService } from '../empresa.service';
import { CustomValidators } from 'ng2-validation';
import { DatepickerOptions } from 'ng2-datepicker';
import { InformacaoReceitaFederal } from '../../../../models/InformacaoReceitaFederal';

@Component({
  selector: 'app-validar-empresa',
  templateUrl: './validar-empresa.component.html',
  styleUrls: ['./validar-empresa.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ValidarEmpresaComponent implements OnInit {
  valForm: FormGroup;
  buttonType: any;
  public searchTyped = new BehaviorSubject('');
  public searchTypedCidades = new BehaviorSubject('');
  public searchTypedVendedor = new BehaviorSubject('');
  router: Router;
  id: any;
  empresa: InformacaoReceitaFederal;
  data: any;
  edicao = false;
  segmentos: Array<any>;

  public mask: Array<string | RegExp>;
  public maskIe: Array<string | RegExp>;
  public maskCep: Array<string | RegExp>;
  public maskData: Array<string | RegExp>;
  cortesia = false;
  parametroPagamentoCadastrar = false;
  options: DatepickerOptions = {
    locale: ptLocale,
    displayFormat: 'DD/MM/YYYY',
    barTitleIfEmpty: 'Clique para selecionar a data',
    placeholder: 'Clique para selecionar a data'
  };
  isChecked: boolean = false;
  // Datepicker
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  bsConfig = {
    containerClass: 'theme-angle',
    dateInputFormat: 'DD/MM/YYYY'
  };

  constructor(public service: EmpresaService,
    public injector: Injector,
    fb: FormBuilder,
    private route: ActivatedRoute,
    private routerNavigate: Router,
    public loader: LoadingService) {

    // INTANCIA O OBJETO
    this.empresa = new InformacaoReceitaFederal();



    this.mask = [/[0-9]/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    this.maskCep = [/[1-9]/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
    this.maskData = [/[1-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    this.maskIe = [/[1-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, '-', /\d/];

    // VALIDAÃ‡ÃƒO DO FORM
    this.valForm = fb.group({
      'receitaFederalEmpresaNome': [null, Validators.required],
      'receitaFederalEmpresaNomeFantasia': [null, null],
      'receitaFederalEmpresaDocumento': [null, Validators.required],
      'receitaFederalEmpresaEmail': [null, CustomValidators.email],
      'receitaFederalEmpresaEstado': [null, null],
      'receitaFederalEmpresaCidade': [null, null],
      'receitaFederalEmpresaBairro': [null, null],
      'receitaFederalEmpresaLogradouro': [null, null],
      'receitaFederalEmpresaCep': [null, null],
      'receitaFederalEmpresaNumero': [null, null],
      'receitaFederalEmpresaResponsavel': [null, null],
      'receitaFederalEmpresaTelefone': [null, null],
      'receitaFederalEmpresaSituacao': [null, null],
      'receitaFederalEmpresaPorte': [null, null],
      'receitaFederalEmpresaTipo': [null, null],
      'receitaFederalEmpresaDataSituacao': [null, null],
      'receitaFederalEmpresaAtividadePrincipal': [null, null],
      'receitaFederalEmpresaAtividadeSecundaria': [null, null],
      'receitaFederalEmpresaQSA': [null, null],
      'receitaFederalEmpresaDataCapitalSocial': [null, null],
      'receitaFederalEmpresaDataAbertura': [null, null],

    });

    this.route.queryParams.subscribe(params => {
      const record = JSON.parse(params['data']);
      this.data = record;
      this.service.obterInformacoesReceita(record.id_empresa)
        .subscribe(itens => {
          this.loader.hide('body');
          if (itens != null)
            this.empresa = itens;
        });
    });

  }


  validarManual() {
    window.open('http://servicos.receita.fazenda.gov.br/Servicos/cnpjreva/cnpjreva_solicitacao.asp', '_blank');
  }
  obterInformacaoNaReceita() {
    this.loader.show('body');
    this.service.atualizarInformacoesReceitaFederal(this.data.id_empresa)
      .subscribe(result => {
        this.loader.hide('body');
        if (result.id_informacao_receita_federal != null) {
          this.empresa = result;
          this.callbackSave(result);
        }
      });

  }
  invalidarEmpresa(): void {

    swal({
      title: 'Atenção',
      text: `Ao marcar o registro dessa empresa como inválido, ela não conseguirar mais usar o Fidel.\n Proseguir com a ação?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1E0136',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      closeOnConfirm: false
    }, () => {
     // swal.close();
      this.loader.show('body');
      this.service.registarEmpresaComoInvalida({id_empresa:this.data.id_empresa})
        .subscribe(result => {
          this.loader.hide("body");
          if (!!result.validado_receita && !!!result.empresa_valida) {

            swal('Atenção', 'Ação realizada com sucesso.', 'success');
          }
        });
    });

  }

  submitForm($ev, value, buttonType: string) {

    $ev.preventDefault();
    // tslint:disable-next-line: forin
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      this.loader.show('body');
      this.empresa.id_empresa = this.data.id_empresa;
      this.service.salvarInformacoesReceita(this.empresa)
        .subscribe(result => {
          this.loader.hide('body');
          if (result.id_informacao_receita_federal != null) {
            this.callbackSave(result);
          }
        });

    }
  }
  callbackSave(result) {
    if (result.success == true) {
      swal('Atenção', 'Informações salva com sucesso para: ' + result.senha + " .", 'success');
      this.valForm.reset();
      this.routerNavigate.navigate(['/v1/empresa']);
    }
  }
  ngOnInit() {
  }

}
